export const SERIALISED_EMOJI_DATA = `
😀 grinning
😃 smiley
😄 smile
😁 grin
😆 laughing satisfied
😅 sweat_smile
😂 joy
🤣 rofl rolling_on_the_floor_laughing
☺️ relaxed
😊 blush
😇 innocent
🙂 slight_smile slightly_smiling_face
🙃 upside_down upside_down_face
😉 wink
😌 relieved
🥲 smiling_face_with_tear
😍 heart_eyes
🥰 smiling_face_with_3_hearts
😘 kissing_heart
😗 kissing
😙 kissing_smiling_eyes
😚 kissing_closed_eyes
😋 yum
😛 stuck_out_tongue
😝 stuck_out_tongue_closed_eyes
😜 stuck_out_tongue_winking_eye
🤪 zany_face
🤨 face_with_raised_eyebrow
🧐 face_with_monocle
🤓 nerd nerd_face
😎 sunglasses
🤩 star_struck
🥳 partying_face
😏 smirk
😒 unamused
😞 disappointed
😔 pensive
😟 worried
😕 confused
🙁 slight_frown slightly_frowning_face
☹️ frowning2 white_frowning_face
😣 persevere
😖 confounded
😫 tired_face
😩 weary
🥺 pleading_face
😢 cry
😭 sob
😤 triumph
😠 angry
😡 rage
🤬 face_with_symbols_over_mouth
🤯 exploding_head
😳 flushed
🥵 hot_face
🥶 cold_face
😱 scream
😨 fearful
😰 cold_sweat
😥 disappointed_relieved
😓 sweat
🤗 hugging hugging_face
🤔 thinking thinking_face
🤭 face_with_hand_over_mouth
🥱 yawning_face
🤫 shushing_face
🤥 lying_face liar
😶 no_mouth
😐 neutral_face
😑 expressionless
😬 grimacing
🙄 rolling_eyes face_with_rolling_eyes
😯 hushed
😦 frowning
😧 anguished
😮 open_mouth
😲 astonished
😴 sleeping
🤤 drooling_face drool
😪 sleepy
😵 dizzy_face
🤐 zipper_mouth zipper_mouth_face
🥴 woozy_face
🤢 nauseated_face sick
🤮 face_vomiting
🤧 sneezing_face sneeze
😷 mask
🤒 thermometer_face face_with_thermometer
🤕 head_bandage face_with_head_bandage
🤑 money_mouth money_mouth_face
🤠 cowboy face_with_cowboy_hat
🥸 disguised_face
😈 smiling_imp
👿 imp
👹 japanese_ogre
👺 japanese_goblin
🤡 clown clown_face
💩 poop shit hankey poo
👻 ghost
💀 skull skeleton
☠️ skull_crossbones skull_and_crossbones
👽 alien
👾 space_invader
🤖 robot robot_face
🎃 jack_o_lantern
😺 smiley_cat
😸 smile_cat
😹 joy_cat
😻 heart_eyes_cat
😼 smirk_cat
😽 kissing_cat
🙀 scream_cat
😿 crying_cat_face
😾 pouting_cat
🤲/+ palms_up_together/#!
👐/+ open_hands/#
🙌/+ raised_hands/#
👏/+ clap/#
🤝 handshake shaking_hands
👍/+ thumbsup/# +1/# thumbup/#
👎/+ thumbsdown/# -1 thumbdown/# _1/#*
👊/+ punch/#
✊/+ fist/#
🤛/+ left_facing_fist/# left_fist/#
🤜/+ right_facing_fist/# right_fist/#
🤞/+ fingers_crossed/# hand_with_index_and_middle_finger_crossed hand_with_index_and_middle_fingers_crossed/#*
✌️/+ v/#
🤟/+ love_you_gesture/#!
🤘/+ metal/# sign_of_the_horns/#
👌/+ ok_hand/#
🤏/+ pinching_hand/#!
🤌/+ pinched_fingers/#!
👈/+ point_left/#
👉/+ point_right/#
👆/+ point_up_2/#
👇/+ point_down/#
☝️/+ point_up/#
✋/+ raised_hand/#
🤚/+ raised_back_of_hand/# back_of_hand/#
🖐️/+ hand_splayed/# raised_hand_with_fingers_splayed/#
🖖/+ vulcan/# raised_hand_with_part_between_middle_and_ring_fingers/#
👋/+ wave/#
🤙/+ call_me/# call_me_hand/#
💪/+ muscle/#
🦾 mechanical_arm
🖕/+ middle_finger/# reversed_hand_with_middle_finger_extended/#
✍️/+ writing_hand/#
🙏/+ pray/#
🦶/+ foot/#!
🦵/+ leg/#!
🦿 mechanical_leg
💄 lipstick
💋 kiss
👄 lips
🦷 tooth
🦴 bone
👅 tongue
👂/+ ear/#
🦻/+ ear_with_hearing_aid/#!
👃/+ nose/#
👣 footprints
👁️ eye
👀 eyes
🧠 brain
🫀 anatomical_heart
🫁 lungs
🗣️ speaking_head speaking_head_in_silhouette
👤 bust_in_silhouette
👥 busts_in_silhouette
🫂 people_hugging
👶/+ baby/#
👧/+ girl/#
🧒/+ child/#!
👦/+ boy/#
👩/+ woman/#
🧑/+ adult/#!
👨/+ man/#
🧑‍🦱/+ person_curly_hair
👩‍🦱/+ woman_curly_haired/#!
👨‍🦱/+ man_curly_haired/#!
🧑‍🦰/+ person_red_hair
👩‍🦰/+ woman_red_haired/#!
👨‍🦰/+ man_red_haired/#!
👱‍♀️/+ blond_haired_woman/#!
👱/+ blond_haired_person/# person_with_blond_hair/#
👱‍♂️/+ blond_haired_man/#!
🧑‍🦳/+ person_white_hair
👩‍🦳/+ woman_white_haired/#!
👨‍🦳/+ man_white_haired/#!
🧑‍🦲/+ person_bald
👩‍🦲/+ woman_bald/#!
👨‍🦲/+ man_bald/#!
🧔/+ bearded_person/#!
👵/+ older_woman/# grandma/#
🧓/+ older_adult/#!
👴/+ older_man/#
👲/+ man_with_chinese_cap/# man_with_gua_pi_mao/#
👳/+ person_wearing_turban/# man_with_turban/#
👳‍♀️/+ woman_wearing_turban/#!
👳‍♂️/+ man_wearing_turban/#!
🧕/+ woman_with_headscarf/#!
👮/+ police_officer/# cop/#
👮‍♀️/+ woman_police_officer/#!
👮‍♂️/+ man_police_officer/#!
👷/+ construction_worker/#
👷‍♀️/+ woman_construction_worker/#!
👷‍♂️/+ man_construction_worker/#!
💂/+ guard/# guardsman/#
💂‍♀️/+ woman_guard/#!
💂‍♂️/+ man_guard/#!
🕵️/+ detective/# spy/# sleuth_or_spy/#
🕵️‍♀️/+ woman_detective/#!
🕵️‍♂️/+ man_detective/#!
🧑‍⚕️/+ health_worker/#!
👩‍⚕️/+ woman_health_worker/#!
👨‍⚕️/+ man_health_worker/#!
🧑‍🌾/+ farmer/#!
👩‍🌾/+ woman_farmer/#!
👨‍🌾/+ man_farmer/#!
🧑‍🍳/+ cook/#!
👩‍🍳/+ woman_cook/#!
👨‍🍳/+ man_cook/#!
🧑‍🎓/+ student/#!
👩‍🎓/+ woman_student/#!
👨‍🎓/+ man_student/#!
🧑‍🎤/+ singer/#!
👩‍🎤/+ woman_singer/#!
👨‍🎤/+ man_singer/#!
🧑‍🏫/+ teacher/#!
👩‍🏫/+ woman_teacher/#!
👨‍🏫/+ man_teacher/#!
🧑‍🏭/+ factory_worker/#!
👩‍🏭/+ woman_factory_worker/#!
👨‍🏭/+ man_factory_worker/#!
🧑‍💻/+ technologist/#!
👩‍💻/+ woman_technologist/#!
👨‍💻/+ man_technologist/#!
🧑‍💼/+ office_worker/#!
👩‍💼/+ woman_office_worker/#!
👨‍💼/+ man_office_worker/#!
🧑‍🔧/+ mechanic/#!
👩‍🔧/+ woman_mechanic/#!
👨‍🔧/+ man_mechanic/#!
🧑‍🔬/+ scientist/#!
👩‍🔬/+ woman_scientist/#!
👨‍🔬/+ man_scientist/#!
🧑‍🎨/+ artist/#!
👩‍🎨/+ woman_artist/#!
👨‍🎨/+ man_artist/#!
🧑‍🚒/+ firefighter/#!
👩‍🚒/+ woman_firefighter/#!
👨‍🚒/+ man_firefighter/#!
🧑‍✈️/+ pilot/#!
👩‍✈️/+ woman_pilot/#!
👨‍✈️/+ man_pilot/#!
🧑‍🚀/+ astronaut/#!
👩‍🚀/+ woman_astronaut/#!
👨‍🚀/+ man_astronaut/#!
🧑‍⚖️/+ judge/#!
👩‍⚖️/+ woman_judge/#!
👨‍⚖️/+ man_judge/#!
👰/+ person_with_veil/#
👰‍♀️/+ woman_with_veil/#! bride_with_veil
👰‍♂️/+ man_with_veil/#!
🤵/+ person_in_tuxedo/# tuxedo/#*
🤵‍♀️/+ woman_in_tuxedo/#!
🤵‍♂️/+ man_in_tuxedo/#!
👸/+ princess/#
🤴/+ prince/#
🦸/+ superhero/#!
🦸‍♀️/+ woman_superhero/#!
🦸‍♂️/+ man_superhero/#!
🦹/+ supervillain/#!
🦹‍♀️/+ woman_supervillain/#!
🦹‍♂️/+ man_supervillain/#!
🥷/+ ninja/#!
🧑‍🎄/+ mx_claus/#!
🤶/+ mrs_claus/# mother_christmas/#
🎅/+ santa/#
🧙/+ mage/#!
🧙‍♀️/+ woman_mage/#!
🧙‍♂️/+ man_mage/#!
🧝/+ elf/#!
🧝‍♀️/+ woman_elf/#!
🧝‍♂️/+ man_elf/#!
🧛/+ vampire/#!
🧛‍♀️/+ woman_vampire/#!
🧛‍♂️/+ man_vampire/#!
🧟 zombie
🧟‍♀️ woman_zombie
🧟‍♂️ man_zombie
🧞 genie
🧞‍♀️ woman_genie
🧞‍♂️ man_genie
🧜/+ merperson/#!
🧜‍♀️/+ mermaid/#!
🧜‍♂️/+ merman/#!
🧚/+ fairy/#!
🧚‍♀️/+ woman_fairy/#!
🧚‍♂️/+ man_fairy/#!
👼/+ angel/#
🤰/+ pregnant_woman/# expecting_woman/#
🤱/+ breast_feeding/#!
🧑‍🍼/+ person_feeding_baby/#!
👩‍🍼/+ woman_feeding_baby/#!
👨‍🍼/+ man_feeding_baby/#!
🙇/+ person_bowing/# bow/#
🙇‍♀️/+ woman_bowing/#!
🙇‍♂️/+ man_bowing/#!
💁/+ person_tipping_hand/# information_desk_person/#
💁‍♀️/+ woman_tipping_hand/#!
💁‍♂️/+ man_tipping_hand/#!
🙅/+ person_gesturing_no/# no_good/#
🙅‍♀️/+ woman_gesturing_no/#!
🙅‍♂️/+ man_gesturing_no/#!
🙆/+ person_gesturing_ok/# ok_woman/#
🙆‍♀️/+ woman_gesturing_ok/#!
🙆‍♂️/+ man_gesturing_ok/#!
🙋/+ person_raising_hand/# raising_hand/#
🙋‍♀️/+ woman_raising_hand/#!
🙋‍♂️/+ man_raising_hand/#!
🧏/+ deaf_person/#!
🧏‍♀️/+ deaf_woman/#!
🧏‍♂️/+ deaf_man/#!
🤦/+ person_facepalming/# face_palm/# facepalm/#
🤦‍♀️/+ woman_facepalming/#!
🤦‍♂️/+ man_facepalming/#!
🤷/+ person_shrugging/# shrug/#
🤷‍♀️/+ woman_shrugging/#!
🤷‍♂️/+ man_shrugging/#!
🙎/+ person_pouting/# person_with_pouting_face/#
🙎‍♀️/+ woman_pouting/#!
🙎‍♂️/+ man_pouting/#!
🙍/+ person_frowning/#
🙍‍♀️/+ woman_frowning/#!
🙍‍♂️/+ man_frowning/#!
💇/+ person_getting_haircut/# haircut/#
💇‍♀️/+ woman_getting_haircut/#!
💇‍♂️/+ man_getting_haircut/#!
💆/+ person_getting_massage/# massage/#
💆‍♀️/+ woman_getting_face_massage/#!
💆‍♂️/+ man_getting_face_massage/#!
🧖/+ person_in_steamy_room/#!
🧖‍♀️/+ woman_in_steamy_room/#!
🧖‍♂️/+ man_in_steamy_room/#!
💅/+ nail_care/#
🤳/+ selfie/#
💃/+ dancer/#
🕺/+ man_dancing/# male_dancer/#
👯 people_with_bunny_ears_partying dancers
👯‍♀️ women_with_bunny_ears_partying
👯‍♂️ men_with_bunny_ears_partying
🕴️/+ levitate/# man_in_business_suit_levitating/#!
🧑‍🦽/+ person_in_manual_wheelchair/#!
👩‍🦽/+ woman_in_manual_wheelchair/#!
👨‍🦽/+ man_in_manual_wheelchair/#!
🧑‍🦼/+ person_in_motorized_wheelchair/#!
👩‍🦼/+ woman_in_motorized_wheelchair/#!
👨‍🦼/+ man_in_motorized_wheelchair/#!
🚶/+ person_walking/# walking/#
🚶‍♀️/+ woman_walking/#!
🚶‍♂️/+ man_walking/#!
🧑‍🦯/+ person_with_probing_cane/#!
👩‍🦯/+ woman_with_probing_cane/#!
👨‍🦯/+ man_with_probing_cane/#!
🧎/+ person_kneeling/#!
🧎‍♀️/+ woman_kneeling/#!
🧎‍♂️/+ man_kneeling/#!
🏃/+ person_running/# runner/#
🏃‍♀️/+ woman_running/#!
🏃‍♂️/+ man_running/#!
🧍/+ person_standing/#!
🧍‍♀️/+ woman_standing/#!
🧍‍♂️/+ man_standing/#!
🧑‍🤝‍🧑 people_holding_hands
👫 couple
👭 two_women_holding_hands
👬 two_men_holding_hands
💑 couple_with_heart
👩‍❤️‍👨 couple_with_heart_woman_man
👩‍❤️‍👩 couple_ww couple_with_heart_ww
👨‍❤️‍👨 couple_mm couple_with_heart_mm
💏 couplekiss
👩‍❤️‍💋‍👨 kiss_woman_man
👩‍❤️‍💋‍👩 kiss_ww couplekiss_ww
👨‍❤️‍💋‍👨 kiss_mm couplekiss_mm
👪 family
👨‍👩‍👦 family_man_woman_boy
👨‍👩‍👧 family_mwg
👨‍👩‍👧‍👦 family_mwgb
👨‍👩‍👦‍👦 family_mwbb
👨‍👩‍👧‍👧 family_mwgg
👩‍👩‍👦 family_wwb
👩‍👩‍👧 family_wwg
👩‍👩‍👧‍👦 family_wwgb
👩‍👩‍👦‍👦 family_wwbb
👩‍👩‍👧‍👧 family_wwgg
👨‍👨‍👦 family_mmb
👨‍👨‍👧 family_mmg
👨‍👨‍👧‍👦 family_mmgb
👨‍👨‍👦‍👦 family_mmbb
👨‍👨‍👧‍👧 family_mmgg
👩‍👦 family_woman_boy
👩‍👧 family_woman_girl
👩‍👧‍👦 family_woman_girl_boy
👩‍👦‍👦 family_woman_boy_boy
👩‍👧‍👧 family_woman_girl_girl
👨‍👦 family_man_boy
👨‍👧 family_man_girl
👨‍👧‍👦 family_man_girl_boy
👨‍👦‍👦 family_man_boy_boy
👨‍👧‍👧 family_man_girl_girl
🧶 yarn
🧵 thread
🧥 coat
🥼 lab_coat
🦺 safety_vest
👚 womans_clothes
👕 shirt
👖 jeans
🩲 briefs
🩳 shorts
👔 necktie
👗 dress
👙 bikini
🩱 one_piece_swimsuit
👘 kimono
🥻 sari
🥿 womans_flat_shoe
👠 high_heel
👡 sandal
👢 boot
👞 mans_shoe
👟 athletic_shoe
🥾 hiking_boot
🩴 thong_sandal
🧦 socks
🧤 gloves
🧣 scarf
🎩 tophat
🧢 billed_cap
👒 womans_hat
🎓 mortar_board
⛑️ helmet_with_cross helmet_with_white_cross
🪖 military_helmet
👑 crown
💍 ring
👝 pouch
👛 purse
👜 handbag
💼 briefcase
🎒 school_satchel
🧳 luggage
👓 eyeglasses
🕶️ dark_sunglasses
🥽 goggles
🌂 closed_umbrella
🐶 dog
🐱 cat
🐭 mouse
🐹 hamster
🐰 rabbit
🦊 fox fox_face
🐻 bear
🐼 panda_face
🐻‍❄️ polar_bear
🐨 koala
🐯 tiger
🦁 lion_face lion
🐮 cow
🐷 pig
🐽 pig_nose
🐸 frog
🐵 monkey_face
🙈 see_no_evil
🙉 hear_no_evil
🙊 speak_no_evil
🐒 monkey
🐔 chicken
🐧 penguin
🐦 bird
🐤 baby_chick
🐣 hatching_chick
🐥 hatched_chick
🦆 duck
🦤 dodo
🦅 eagle
🦉 owl
🦇 bat
🐺 wolf
🐗 boar
🐴 horse
🦄 unicorn unicorn_face
🐝 bee
🐛 bug
🦋 butterfly
🐌 snail
🪱 worm
🐞 lady_beetle
🐜 ant
🪰 fly
🦟 mosquito
🪳 cockroach
🪲 beetle
🦗 cricket
🕷️ spider
🕸️ spider_web
🦂 scorpion
🐢 turtle
🐍 snake
🦎 lizard
🦖 t_rex
🦕 sauropod
🐙 octopus
🦑 squid
🦐 shrimp
🦞 lobster
🦀 crab
🐡 blowfish
🐠 tropical_fish
🐟 fish
🦭 seal
🐬 dolphin
🐳 whale
🐋 whale2
🦈 shark
🐊 crocodile
🐅 tiger2
🐆 leopard
🦓 zebra
🦍 gorilla
🦧 orangutan
🐘 elephant
🦣 mammoth
🦬 bison
🦛 hippopotamus
🦏 rhino rhinoceros
🐪 dromedary_camel
🐫 camel
🦒 giraffe
🦘 kangaroo
🐃 water_buffalo
🐂 ox
🐄 cow2
🐎 racehorse
🐖 pig2
🐏 ram
🐑 sheep
🦙 llama
🐐 goat
🦌 deer
🐕 dog2
🐩 poodle
🦮 guide_dog
🐕‍🦺 service_dog
🐈 cat2
🐈‍⬛ black_cat
🐓 rooster
🦃 turkey
🦚 peacock
🦜 parrot
🦢 swan
🦩 flamingo
🕊️ dove dove_of_peace
🐇 rabbit2
🦝 raccoon
🦨 skunk
🦡 badger
🦫 beaver
🦦 otter
🦥 sloth
🐁 mouse2
🐀 rat
🐿️ chipmunk
🦔 hedgehog
🐾 feet paw_prints
🐉 dragon
🐲 dragon_face
🌵 cactus
🎄 christmas_tree
🌲 evergreen_tree
🌳 deciduous_tree
🌴 palm_tree
🌱 seedling
🌿 herb
☘️ shamrock
🍀 four_leaf_clover
🎍 bamboo
🎋 tanabata_tree
🍃 leaves
🍂 fallen_leaf
🍁 maple_leaf
🪶 feather
🍄 mushroom
🐚 shell
🪨 rock
🪵 wood
🌾 ear_of_rice
🪴 potted_plant
💐 bouquet
🌷 tulip
🌹 rose
🥀 wilted_rose wilted_flower
🌺 hibiscus
🌸 cherry_blossom
🌼 blossom
🌻 sunflower
🌞 sun_with_face
🌝 full_moon_with_face
🌛 first_quarter_moon_with_face
🌜 last_quarter_moon_with_face
🌚 new_moon_with_face
🌕 full_moon
🌖 waning_gibbous_moon
🌗 last_quarter_moon
🌘 waning_crescent_moon
🌑 new_moon
🌒 waxing_crescent_moon
🌓 first_quarter_moon
🌔 waxing_gibbous_moon
🌙 crescent_moon
🌎 earth_americas
🌍 earth_africa
🌏 earth_asia
🪐 ringed_planet
💫 dizzy
⭐ star
🌟 star2
✨ sparkles
⚡ zap
☄️ comet
💥 boom
🔥 fire flame
🌪️ cloud_tornado cloud_with_tornado
🌈 rainbow
☀️ sunny
🌤️ white_sun_small_cloud white_sun_with_small_cloud
⛅ partly_sunny
🌥️ white_sun_cloud white_sun_behind_cloud
☁️ cloud
🌦️ white_sun_rain_cloud white_sun_behind_cloud_with_rain
🌧️ cloud_rain cloud_with_rain
⛈️ thunder_cloud_rain thunder_cloud_and_rain
🌩️ cloud_lightning cloud_with_lightning
🌨️ cloud_snow cloud_with_snow
❄️ snowflake
☃️ snowman2
⛄ snowman
🌬️ wind_blowing_face
💨 dash
💧 droplet
💦 sweat_drops
☔ umbrella
☂️ umbrella2
🌊 ocean
🌫️ fog
🍏 green_apple
🍎 apple
🍐 pear
🍊 tangerine
🍋 lemon
🍌 banana
🍉 watermelon
🍇 grapes
🫐 blueberries
🍓 strawberry
🍈 melon
🍒 cherries
🍑 peach
🥭 mango
🍍 pineapple
🥥 coconut
🥝 kiwi kiwifruit
🍅 tomato
🍆 eggplant
🥑 avocado
🫒 olive
🥦 broccoli
🥬 leafy_green
🫑 bell_pepper
🥒 cucumber
🌶️ hot_pepper
🌽 corn
🥕 carrot
🧄 garlic
🧅 onion
🥔 potato
🍠 sweet_potato
🥐 croissant
🥯 bagel
🍞 bread
🥖 french_bread baguette_bread
🫓 flatbread
🥨 pretzel
🧀 cheese cheese_wedge
🥚 egg
🍳 cooking
🧈 butter
🥞 pancakes
🧇 waffle
🥓 bacon
🥩 cut_of_meat
🍗 poultry_leg
🍖 meat_on_bone
🌭 hotdog hot_dog
🍔 hamburger
🍟 fries
🍕 pizza
🥪 sandwich
🥙 stuffed_flatbread stuffed_pita
🧆 falafel
🌮 taco
🌯 burrito
🫔 tamale
🥗 salad green_salad
🥘 shallow_pan_of_food paella
🫕 fondue
🥫 canned_food
🍝 spaghetti
🍜 ramen
🍲 stew
🍛 curry
🍣 sushi
🍱 bento
🥟 dumpling
🦪 oyster
🍤 fried_shrimp
🍙 rice_ball
🍚 rice
🍘 rice_cracker
🍥 fish_cake
🥠 fortune_cookie
🥮 moon_cake
🍢 oden
🍡 dango
🍧 shaved_ice
🍨 ice_cream
🍦 icecream
🥧 pie
🧁 cupcake
🍰 cake
🎂 birthday
🍮 custard pudding flan
🍭 lollipop
🍬 candy
🍫 chocolate_bar
🍿 popcorn
🍩 doughnut
🍪 cookie
🌰 chestnut
🥜 peanuts shelled_peanut
🍯 honey_pot
🥛 milk glass_of_milk
🍼 baby_bottle
☕ coffee
🍵 tea
🫖 teapot
🧉 mate
🧋 bubble_tea
🧃 beverage_box
🥤 cup_with_straw
🍶 sake
🍺 beer
🍻 beers
🥂 champagne_glass clinking_glass
🍷 wine_glass
🥃 tumbler_glass whisky
🍸 cocktail
🍹 tropical_drink
🍾 champagne bottle_with_popping_cork
🧊 ice_cube
🥄 spoon
🍴 fork_and_knife
🍽️ fork_knife_plate fork_and_knife_with_plate
🥣 bowl_with_spoon
🥡 takeout_box
🥢 chopsticks
🧂 salt
⚽ soccer
🏀 basketball
🏈 football
⚾ baseball
🥎 softball
🎾 tennis
🏐 volleyball
🏉 rugby_football
🥏 flying_disc
🪃 boomerang
🎱 8ball
🪀 yo_yo
🏓 ping_pong table_tennis
🏸 badminton
🏒 hockey
🏑 field_hockey
🥍 lacrosse
🏏 cricket_game cricket_bat_ball
🥅 goal goal_net
⛳ golf
🪁 kite
🏹 bow_and_arrow archery
🎣 fishing_pole_and_fish
🤿 diving_mask
🥊 boxing_glove boxing_gloves
🥋 martial_arts_uniform karate_uniform
🎽 running_shirt_with_sash
🛹 skateboard
🛼 roller_skate
🛷 sled
⛸️ ice_skate
🥌 curling_stone
🎿 ski
⛷️ skier
🏂/+ snowboarder/#!
🪂 parachute
🏋️/+ person_lifting_weights/# lifter/# weight_lifter/#
🏋️‍♀️/+ woman_lifting_weights/#!
🏋️‍♂️/+ man_lifting_weights/#!
🤼 people_wrestling wrestlers wrestling
🤼‍♀️ women_wrestling
🤼‍♂️ men_wrestling
🤸/+ person_doing_cartwheel/# cartwheel/#
🤸‍♀️/+ woman_cartwheeling/#!
🤸‍♂️/+ man_cartwheeling/#!
⛹️/+ person_bouncing_ball/# basketball_player/# person_with_ball/#
⛹️‍♀️/+ woman_bouncing_ball/#!
⛹️‍♂️/+ man_bouncing_ball/#!
🤺 person_fencing fencer fencing
🤾/+ person_playing_handball/# handball/#
🤾‍♀️/+ woman_playing_handball/#!
🤾‍♂️/+ man_playing_handball/#!
🏌️/+ person_golfing/#! golfer
🏌️‍♀️/+ woman_golfing/#!
🏌️‍♂️/+ man_golfing/#!
🏇/+ horse_racing/#
🧘/+ person_in_lotus_position/#!
🧘‍♀️/+ woman_in_lotus_position/#!
🧘‍♂️/+ man_in_lotus_position/#!
🏄/+ person_surfing/# surfer/#
🏄‍♀️/+ woman_surfing/#!
🏄‍♂️/+ man_surfing/#!
🏊/+ person_swimming/# swimmer/#
🏊‍♀️/+ woman_swimming/#!
🏊‍♂️/+ man_swimming/#!
🤽/+ person_playing_water_polo/# water_polo/#
🤽‍♀️/+ woman_playing_water_polo/#!
🤽‍♂️/+ man_playing_water_polo/#!
🚣/+ person_rowing_boat/# rowboat/#
🚣‍♀️/+ woman_rowing_boat/#!
🚣‍♂️/+ man_rowing_boat/#!
🧗/+ person_climbing/#!
🧗‍♀️/+ woman_climbing/#!
🧗‍♂️/+ man_climbing/#!
🚵/+ person_mountain_biking/# mountain_bicyclist/#
🚵‍♀️/+ woman_mountain_biking/#!
🚵‍♂️/+ man_mountain_biking/#!
🚴/+ person_biking/# bicyclist/#
🚴‍♀️/+ woman_biking/#!
🚴‍♂️/+ man_biking/#!
🏆 trophy
🥇 first_place first_place_medal
🥈 second_place second_place_medal
🥉 third_place third_place_medal
🏅 medal sports_medal
🎖️ military_medal
🏵️ rosette
🎗️ reminder_ribbon
🎫 ticket
🎟️ tickets admission_tickets
🎪 circus_tent
🤹/+ person_juggling/# juggling/# juggler/#
🤹‍♀️/+ woman_juggling/#!
🤹‍♂️/+ man_juggling/#!
🎭 performing_arts
🩰 ballet_shoes
🎨 art
🎬 clapper
🎤 microphone
🎧 headphones
🎼 musical_score
🎹 musical_keyboard
🥁 drum drum_with_drumsticks
🪘 long_drum
🎷 saxophone
🎺 trumpet
🎸 guitar
🪕 banjo
🎻 violin
🪗 accordion
🎲 game_die
♟️ chess_pawn
🎯 dart
🎳 bowling
🎮 video_game
🎰 slot_machine
🧩 jigsaw
🚗 red_car
🚕 taxi
🚙 blue_car
🛻 pickup_truck
🚌 bus
🚎 trolleybus
🏎️ race_car racing_car
🚓 police_car
🚑 ambulance
🚒 fire_engine
🚐 minibus
🚚 truck
🚛 articulated_lorry
🚜 tractor
🦯 probing_cane
🦽 manual_wheelchair
🦼 motorized_wheelchair
🛴 scooter
🚲 bike
🛵 motor_scooter motorbike
🏍️ motorcycle racing_motorcycle
🛺 auto_rickshaw
🚨 rotating_light
🚔 oncoming_police_car
🚍 oncoming_bus
🚘 oncoming_automobile
🚖 oncoming_taxi
🚡 aerial_tramway
🚠 mountain_cableway
🚟 suspension_railway
🚃 railway_car
🚋 train
🚞 mountain_railway
🚝 monorail
🚄 bullettrain_side
🚅 bullettrain_front
🚈 light_rail
🚂 steam_locomotive
🚆 train2
🚇 metro
🚊 tram
🚉 station
✈️ airplane
🛫 airplane_departure
🛬 airplane_arriving
🛩️ airplane_small small_airplane
💺 seat
🛰️ satellite_orbital
🚀 rocket
🛸 flying_saucer
🚁 helicopter
🛶 canoe kayak
⛵ sailboat
🚤 speedboat
🛥️ motorboat
🛳️ cruise_ship passenger_ship
⛴️ ferry
🚢 ship
⚓ anchor
⛽ fuelpump
🚧 construction
🚦 vertical_traffic_light
🚥 traffic_light
🚏 busstop
🗺️ map world_map
🗿 moyai
🗽 statue_of_liberty
🗼 tokyo_tower
🏰 european_castle
🏯 japanese_castle
🏟️ stadium
🎡 ferris_wheel
🎢 roller_coaster
🎠 carousel_horse
⛲ fountain
⛱️ beach_umbrella umbrella_on_ground
🏖️ beach beach_with_umbrella
🏝️ island desert_island
🏜️ desert
🌋 volcano
⛰️ mountain
🏔️ mountain_snow snow_capped_mountain
🗻 mount_fuji
🏕️ camping
⛺ tent
🏠 house
🏡 house_with_garden
🏘️ homes house_buildings
🏚️ house_abandoned derelict_house_building
🛖 hut
🏗️ construction_site building_construction
🏭 factory
🏢 office
🏬 department_store
🏣 post_office
🏤 european_post_office
🏥 hospital
🏦 bank
🏨 hotel
🏪 convenience_store
🏫 school
🏩 love_hotel
💒 wedding
🏛️ classical_building
⛪ church
🕌 mosque
🕍 synagogue
🛕 hindu_temple
🕋 kaaba
⛩️ shinto_shrine
🛤️ railway_track railroad_track
🛣️ motorway
🗾 japan
🎑 rice_scene
🏞️ park national_park
🌅 sunrise
🌄 sunrise_over_mountains
🌠 stars
🎇 sparkler
🎆 fireworks
🌇 city_sunset city_sunrise
🌆 city_dusk
🏙️ cityscape
🌃 night_with_stars
🌌 milky_way
🌉 bridge_at_night
🌁 foggy
⌚ watch
📱 mobile_phone iphone
📲 calling
💻 computer
⌨️ keyboard
🖥️ desktop desktop_computer
🖨️ printer
🖱️ mouse_three_button three_button_mouse
🖲️ trackball
🕹️ joystick
🗜️ compression
💽 minidisc
💾 floppy_disk
💿 cd
📀 dvd
📼 vhs
📷 camera
📸 camera_with_flash
📹 video_camera
🎥 movie_camera
📽️ projector film_projector
🎞️ film_frames
📞 telephone_receiver
☎️ telephone
📟 pager
📠 fax
📺 tv
📻 radio
🎙️ microphone2 studio_microphone
🎚️ level_slider
🎛️ control_knobs
🧭 compass
⏱️ stopwatch
⏲️ timer timer_clock
⏰ alarm_clock
🕰️ clock mantlepiece_clock
⌛ hourglass
⏳ hourglass_flowing_sand
📡 satellite
🔋 battery
🔌 electric_plug
💡 bulb
🔦 flashlight
🕯️ candle
🪔 diya_lamp
🧯 fire_extinguisher
🛢️ oil oil_drum
💸 money_with_wings
💵 dollar
💴 yen
💶 euro
💷 pound
🪙 coin
💰 moneybag
💳 credit_card
💎 gem
⚖️ scales
🪜 ladder
🧰 toolbox
🪛 screwdriver
🔧 wrench
🔨 hammer
⚒️ hammer_pick hammer_and_pick
🛠️ tools hammer_and_wrench
⛏️ pick
🔩 nut_and_bolt
⚙️ gear
🧱 bricks
⛓️ chains
🪝 hook
🪢 knot
🧲 magnet
🔫 gun
💣 bomb
🧨 firecracker
🪓 axe
🪚 carpentry_saw
🔪 knife
🗡️ dagger dagger_knife
⚔️ crossed_swords
🛡️ shield
🚬 smoking
⚰️ coffin
🪦 headstone
⚱️ urn funeral_urn
🏺 amphora
🪄 magic_wand
🔮 crystal_ball
📿 prayer_beads
🧿 nazar_amulet
💈 barber
⚗️ alembic
🔭 telescope
🔬 microscope
🕳️ hole
🪟 window
🩹 adhesive_bandage
🩺 stethoscope
💊 pill
💉 syringe
🩸 drop_of_blood
🧬 dna
🦠 microbe
🧫 petri_dish
🧪 test_tube
🌡️ thermometer
🪤 mouse_trap
🧹 broom
🧺 basket
🪡 sewing_needle
🧻 roll_of_paper
🚽 toilet
🪠 plunger
🪣 bucket
🚰 potable_water
🚿 shower
🛁 bathtub
🛀/+ bath/#
🪥 toothbrush
🧼 soap
🪒 razor
🧽 sponge
🧴 squeeze_bottle
🛎️ bellhop bellhop_bell
🔑 key
🗝️ key2 old_key
🚪 door
🪑 chair
🪞 mirror
🛋️ couch couch_and_lamp
🛏️ bed
🛌/+ sleeping_accommodation person_in_bed/#!*
🧸 teddy_bear
🖼️ frame_photo frame_with_picture
🛍️ shopping_bags
🛒 shopping_cart shopping_trolley
🎁 gift
🎈 balloon
🎏 flags
🎀 ribbon
🎊 confetti_ball
🎉 tada
🪅 piñata
🪆 nesting_dolls
🎎 dolls
🏮 izakaya_lantern
🎐 wind_chime
🧧 red_envelope
✉️ envelope
📩 envelope_with_arrow
📨 incoming_envelope
📧 e_mail email
💌 love_letter
📥 inbox_tray
📤 outbox_tray
📦 package
🏷️ label
📪 mailbox_closed
📫 mailbox
📬 mailbox_with_mail
📭 mailbox_with_no_mail
📮 postbox
📯 postal_horn
🪧 placard
📜 scroll
📃 page_with_curl
📄 page_facing_up
📑 bookmark_tabs
🧾 receipt
📊 bar_chart
📈 chart_with_upwards_trend
📉 chart_with_downwards_trend
🗒️ notepad_spiral spiral_note_pad
🗓️ calendar_spiral spiral_calendar_pad
📆 calendar
📅 date
🗑️ wastebasket
📇 card_index
🗃️ card_box card_file_box
🗳️ ballot_box ballot_box_with_ballot
🗄️ file_cabinet
📋 clipboard
📁 file_folder
📂 open_file_folder
🗂️ dividers card_index_dividers
🗞️ newspaper2 rolled_up_newspaper
📰 newspaper
📓 notebook
📔 notebook_with_decorative_cover
📒 ledger
📕 closed_book
📗 green_book
📘 blue_book
📙 orange_book
📚 books
📖 book
🔖 bookmark
🧷 safety_pin
🔗 link
📎 paperclip
🖇️ paperclips linked_paperclips
📐 triangular_ruler
📏 straight_ruler
🧮 abacus
📌 pushpin
📍 round_pushpin
✂️ scissors
🖊️ pen_ballpoint lower_left_ballpoint_pen
🖋️ pen_fountain lower_left_fountain_pen
✒️ black_nib
🖌️ paintbrush lower_left_paintbrush
🖍️ crayon lower_left_crayon
📝 pencil memo
✏️ pencil2
🔍 mag
🔎 mag_right
🔏 lock_with_ink_pen
🔐 closed_lock_with_key
🔒 lock
🔓 unlock
❤️ heart
🧡 orange_heart
💛 yellow_heart
💚 green_heart
💙 blue_heart
💜 purple_heart
🖤 black_heart
🤎 brown_heart
🤍 white_heart
💔 broken_heart
❣️ heart_exclamation heavy_heart_exclamation_mark_ornament
💕 two_hearts
💞 revolving_hearts
💓 heartbeat
💗 heartpulse
💖 sparkling_heart
💘 cupid
💝 gift_heart
💟 heart_decoration
☮️ peace peace_symbol
✝️ cross latin_cross
☪️ star_and_crescent
🕉️ om_symbol
☸️ wheel_of_dharma
✡️ star_of_david
🔯 six_pointed_star
🕎 menorah
☯️ yin_yang
☦️ orthodox_cross
🛐 place_of_worship worship_symbol
⛎ ophiuchus
♈ aries
♉ taurus
♊ gemini
♋ cancer
♌ leo
♍ virgo
♎ libra
♏ scorpius
♐ sagittarius
♑ capricorn
♒ aquarius
♓ pisces
🆔 id
⚛️ atom atom_symbol
🉑 accept
☢️ radioactive radioactive_sign
☣️ biohazard biohazard_sign
📴 mobile_phone_off
📳 vibration_mode
🈶 u6709
🈚 u7121
🈸 u7533
🈺 u55b6
🈷️ u6708
✴️ eight_pointed_black_star
🆚 vs
💮 white_flower
🉐 ideograph_advantage
㊙️ secret
㊗️ congratulations
🈴 u5408
🈵 u6e80
🈹 u5272
🈲 u7981
🅰️ a
🅱️ b
🆎 ab
🆑 cl
🅾️ o2
🆘 sos
❌ x
⭕ o
🛑 octagonal_sign stop_sign
⛔ no_entry
📛 name_badge
🚫 no_entry_sign
💯 100
💢 anger
♨️ hotsprings
🚷 no_pedestrians
🚯 do_not_litter
🚳 no_bicycles
🚱 non_potable_water
🔞 underage
📵 no_mobile_phones
🚭 no_smoking
❗ exclamation
❕ grey_exclamation
❓ question
❔ grey_question
‼️ bangbang
⁉️ interrobang
🔅 low_brightness
🔆 high_brightness
〽️ part_alternation_mark
⚠️ warning
🚸 children_crossing
🔱 trident
⚜️ fleur_de_lis
🔰 beginner
♻️ recycle
✅ white_check_mark
🈯 u6307
💹 chart
❇️ sparkle
✳️ eight_spoked_asterisk
❎ negative_squared_cross_mark
🌐 globe_with_meridians
💠 diamond_shape_with_a_dot_inside
Ⓜ️ m
🌀 cyclone
💤 zzz
🏧 atm
🚾 wc
♿ wheelchair
🅿️ parking
🈳 u7a7a
🈂️ sa
🛂 passport_control
🛃 customs
🛄 baggage_claim
🛅 left_luggage
🛗 elevator
🚹 mens
🚺 womens
🚼 baby_symbol
🚻 restroom
🚮 put_litter_in_its_place
🎦 cinema
📶 signal_strength
🈁 koko
🔣 symbols
ℹ️ information_source
🔤 abc
🔡 abcd
🔠 capital_abcd
🆖 ng
🆗 ok
🆙 up
🆒 cool
🆕 new
🆓 free
0️⃣ zero
1️⃣ one
2️⃣ two
3️⃣ three
4️⃣ four
5️⃣ five
6️⃣ six
7️⃣ seven
8️⃣ eight
9️⃣ nine
🔟 keycap_ten
🔢 1234
#️⃣ hash
*️⃣ asterisk keycap_asterisk
⏏️ eject eject_symbol
▶️ arrow_forward
⏸️ pause_button double_vertical_bar
⏯️ play_pause
⏹️ stop_button
⏺️ record_button
⏭️ track_next next_track
⏮️ track_previous previous_track
⏩ fast_forward
⏪ rewind
⏫ arrow_double_up
⏬ arrow_double_down
◀️ arrow_backward
🔼 arrow_up_small
🔽 arrow_down_small
➡️ arrow_right
⬅️ arrow_left
⬆️ arrow_up
⬇️ arrow_down
↗️ arrow_upper_right
↘️ arrow_lower_right
↙️ arrow_lower_left
↖️ arrow_upper_left
↕️ arrow_up_down
↔️ left_right_arrow
↪️ arrow_right_hook
↩️ leftwards_arrow_with_hook
⤴️ arrow_heading_up
⤵️ arrow_heading_down
🔀 twisted_rightwards_arrows
🔁 repeat
🔂 repeat_one
🔄 arrows_counterclockwise
🔃 arrows_clockwise
🎵 musical_note
🎶 notes
➕ heavy_plus_sign
➖ heavy_minus_sign
➗ heavy_division_sign
✖️ heavy_multiplication_x
♾️ infinity
💲 heavy_dollar_sign
💱 currency_exchange
™️ tm
©️ copyright
®️ registered
〰️ wavy_dash
➰ curly_loop
➿ loop
🔚 end
🔙 back
🔛 on
🔝 top
🔜 soon
✔️ heavy_check_mark
☑️ ballot_box_with_check
🔘 radio_button
⚪ white_circle
⚫ black_circle
🔴 red_circle
🔵 blue_circle
🟤 brown_circle
🟣 purple_circle
🟢 green_circle
🟡 yellow_circle
🟠 orange_circle
🔺 small_red_triangle
🔻 small_red_triangle_down
🔸 small_orange_diamond
🔹 small_blue_diamond
🔶 large_orange_diamond
🔷 large_blue_diamond
🔳 white_square_button
🔲 black_square_button
▪️ black_small_square
▫️ white_small_square
◾ black_medium_small_square
◽ white_medium_small_square
◼️ black_medium_square
◻️ white_medium_square
⬛ black_large_square
⬜ white_large_square
🟧 orange_square
🟦 blue_square
🟥 red_square
🟫 brown_square
🟪 purple_square
🟩 green_square
🟨 yellow_square
🔈 speaker
🔇 mute
🔉 sound
🔊 loud_sound
🔔 bell
🔕 no_bell
📣 mega
📢 loudspeaker
🗨️ speech_left left_speech_bubble
👁‍🗨 eye_in_speech_bubble
💬 speech_balloon
💭 thought_balloon
🗯️ anger_right right_anger_bubble
♠️ spades
♣️ clubs
♥️ hearts
♦️ diamonds
🃏 black_joker
🎴 flower_playing_cards
🀄 mahjong
🕐 clock1
🕑 clock2
🕒 clock3
🕓 clock4
🕔 clock5
🕕 clock6
🕖 clock7
🕗 clock8
🕘 clock9
🕙 clock10
🕚 clock11
🕛 clock12
🕜 clock130
🕝 clock230
🕞 clock330
🕟 clock430
🕠 clock530
🕡 clock630
🕢 clock730
🕣 clock830
🕤 clock930
🕥 clock1030
🕦 clock1130
🕧 clock1230
♀️ female_sign
♂️ male_sign
⚧ transgender_symbol
⚕️ medical_symbol
🇿 regional_indicator_z
🇾 regional_indicator_y
🇽 regional_indicator_x
🇼 regional_indicator_w
🇻 regional_indicator_v
🇺 regional_indicator_u
🇹 regional_indicator_t
🇸 regional_indicator_s
🇷 regional_indicator_r
🇶 regional_indicator_q
🇵 regional_indicator_p
🇴 regional_indicator_o
🇳 regional_indicator_n
🇲 regional_indicator_m
🇱 regional_indicator_l
🇰 regional_indicator_k
🇯 regional_indicator_j
🇮 regional_indicator_i
🇭 regional_indicator_h
🇬 regional_indicator_g
🇫 regional_indicator_f
🇪 regional_indicator_e
🇩 regional_indicator_d
🇨 regional_indicator_c
🇧 regional_indicator_b
🇦 regional_indicator_a
🏳️ flag_white
🏴 flag_black
🏁 checkered_flag
🚩 triangular_flag_on_post
🏳️‍🌈 rainbow_flag gay_pride_flag
🏳️‍⚧️ transgender_flag
🏴‍☠️ pirate_flag
🇦🇫 flag_af
🇦🇽 flag_ax
🇦🇱 flag_al
🇩🇿 flag_dz
🇦🇸 flag_as
🇦🇩 flag_ad
🇦🇴 flag_ao
🇦🇮 flag_ai
🇦🇶 flag_aq
🇦🇬 flag_ag
🇦🇷 flag_ar
🇦🇲 flag_am
🇦🇼 flag_aw
🇦🇺 flag_au
🇦🇹 flag_at
🇦🇿 flag_az
🇧🇸 flag_bs
🇧🇭 flag_bh
🇧🇩 flag_bd
🇧🇧 flag_bb
🇧🇾 flag_by
🇧🇪 flag_be
🇧🇿 flag_bz
🇧🇯 flag_bj
🇧🇲 flag_bm
🇧🇹 flag_bt
🇧🇴 flag_bo
🇧🇦 flag_ba
🇧🇼 flag_bw
🇧🇷 flag_br
🇮🇴 flag_io
🇻🇬 flag_vg
🇧🇳 flag_bn
🇧🇬 flag_bg
🇧🇫 flag_bf
🇧🇮 flag_bi
🇰🇭 flag_kh
🇨🇲 flag_cm
🇨🇦 flag_ca
🇮🇨 flag_ic
🇨🇻 flag_cv
🇧🇶 flag_bq
🇰🇾 flag_ky
🇨🇫 flag_cf
🇹🇩 flag_td
🇨🇱 flag_cl
🇨🇳 flag_cn
🇨🇽 flag_cx
🇨🇨 flag_cc
🇨🇴 flag_co
🇰🇲 flag_km
🇨🇬 flag_cg
🇨🇩 flag_cd
🇨🇰 flag_ck
🇨🇷 flag_cr
🇨🇮 flag_ci
🇭🇷 flag_hr
🇨🇺 flag_cu
🇨🇼 flag_cw
🇨🇾 flag_cy
🇨🇿 flag_cz
🇩🇰 flag_dk
🇩🇯 flag_dj
🇩🇲 flag_dm
🇩🇴 flag_do
🇪🇨 flag_ec
🇪🇬 flag_eg
🇸🇻 flag_sv
🇬🇶 flag_gq
🇪🇷 flag_er
🇪🇪 flag_ee
🇪🇹 flag_et
🇪🇺 flag_eu
🇫🇰 flag_fk
🇫🇴 flag_fo
🇫🇯 flag_fj
🇫🇮 flag_fi
🇫🇷 flag_fr
🇬🇫 flag_gf
🇵🇫 flag_pf
🇹🇫 flag_tf
🇬🇦 flag_ga
🇬🇲 flag_gm
🇬🇪 flag_ge
🇩🇪 flag_de
🇬🇭 flag_gh
🇬🇮 flag_gi
🇬🇷 flag_gr
🇬🇱 flag_gl
🇬🇩 flag_gd
🇬🇵 flag_gp
🇬🇺 flag_gu
🇬🇹 flag_gt
🇬🇬 flag_gg
🇬🇳 flag_gn
🇬🇼 flag_gw
🇬🇾 flag_gy
🇭🇹 flag_ht
🇭🇳 flag_hn
🇭🇰 flag_hk
🇭🇺 flag_hu
🇮🇸 flag_is
🇮🇳 flag_in
🇮🇩 flag_id
🇮🇷 flag_ir
🇮🇶 flag_iq
🇮🇪 flag_ie
🇮🇲 flag_im
🇮🇱 flag_il
🇮🇹 flag_it
🇯🇲 flag_jm
🇯🇵 flag_jp
🎌 crossed_flags
🇯🇪 flag_je
🇯🇴 flag_jo
🇰🇿 flag_kz
🇰🇪 flag_ke
🇰🇮 flag_ki
🇽🇰 flag_xk
🇰🇼 flag_kw
🇰🇬 flag_kg
🇱🇦 flag_la
🇱🇻 flag_lv
🇱🇧 flag_lb
🇱🇸 flag_ls
🇱🇷 flag_lr
🇱🇾 flag_ly
🇱🇮 flag_li
🇱🇹 flag_lt
🇱🇺 flag_lu
🇲🇴 flag_mo
🇲🇰 flag_mk
🇲🇬 flag_mg
🇲🇼 flag_mw
🇲🇾 flag_my
🇲🇻 flag_mv
🇲🇱 flag_ml
🇲🇹 flag_mt
🇲🇭 flag_mh
🇲🇶 flag_mq
🇲🇷 flag_mr
🇲🇺 flag_mu
🇾🇹 flag_yt
🇲🇽 flag_mx
🇫🇲 flag_fm
🇲🇩 flag_md
🇲🇨 flag_mc
🇲🇳 flag_mn
🇲🇪 flag_me
🇲🇸 flag_ms
🇲🇦 flag_ma
🇲🇿 flag_mz
🇲🇲 flag_mm
🇳🇦 flag_na
🇳🇷 flag_nr
🇳🇵 flag_np
🇳🇱 flag_nl
🇳🇨 flag_nc
🇳🇿 flag_nz
🇳🇮 flag_ni
🇳🇪 flag_ne
🇳🇬 flag_ng
🇳🇺 flag_nu
🇳🇫 flag_nf
🇰🇵 flag_kp
🇲🇵 flag_mp
🇳🇴 flag_no
🇴🇲 flag_om
🇵🇰 flag_pk
🇵🇼 flag_pw
🇵🇸 flag_ps
🇵🇦 flag_pa
🇵🇬 flag_pg
🇵🇾 flag_py
🇵🇪 flag_pe
🇵🇭 flag_ph
🇵🇳 flag_pn
🇵🇱 flag_pl
🇵🇹 flag_pt
🇵🇷 flag_pr
🇶🇦 flag_qa
🇷🇪 flag_re
🇷🇴 flag_ro
🇷🇺 flag_ru
🇷🇼 flag_rw
🇼🇸 flag_ws
🇸🇲 flag_sm
🇸🇹 flag_st
🇸🇦 flag_sa
🇸🇳 flag_sn
🇷🇸 flag_rs
🇸🇨 flag_sc
🇸🇱 flag_sl
🇸🇬 flag_sg
🇸🇽 flag_sx
🇸🇰 flag_sk
🇸🇮 flag_si
🇬🇸 flag_gs
🇸🇧 flag_sb
🇸🇴 flag_so
🇿🇦 flag_za
🇰🇷 flag_kr
🇸🇸 flag_ss
🇪🇸 flag_es
🇱🇰 flag_lk
🇧🇱 flag_bl
🇸🇭 flag_sh
🇰🇳 flag_kn
🇱🇨 flag_lc
🇵🇲 flag_pm
🇻🇨 flag_vc
🇸🇩 flag_sd
🇸🇷 flag_sr
🇸🇿 flag_sz
🇸🇪 flag_se
🇨🇭 flag_ch
🇸🇾 flag_sy
🇹🇼 flag_tw
🇹🇯 flag_tj
🇹🇿 flag_tz
🇹🇭 flag_th
🇹🇱 flag_tl
🇹🇬 flag_tg
🇹🇰 flag_tk
🇹🇴 flag_to
🇹🇹 flag_tt
🇹🇳 flag_tn
🇹🇷 flag_tr
🇹🇲 flag_tm
🇹🇨 flag_tc
🇻🇮 flag_vi
🇹🇻 flag_tv
🇺🇬 flag_ug
🇺🇦 flag_ua
🇦🇪 flag_ae
🇬🇧 flag_gb
🏴󠁧󠁢󠁥󠁮󠁧󠁿 england
🏴󠁧󠁢󠁳󠁣󠁴󠁿 scotland
🏴󠁧󠁢󠁷󠁬󠁳󠁿 wales
🇺🇸 flag_us
🇺🇾 flag_uy
🇺🇿 flag_uz
🇻🇺 flag_vu
🇻🇦 flag_va
🇻🇪 flag_ve
🇻🇳 flag_vn
🇼🇫 flag_wf
🇪🇭 flag_eh
🇾🇪 flag_ye
🇿🇲 flag_zm
🇿🇼 flag_zw
🇦🇨 flag_ac
🇧🇻 flag_bv
🇨🇵 flag_cp
🇪🇦 flag_ea
🇩🇬 flag_dg
🇭🇲 flag_hm
🇲🇫 flag_mf
🇸🇯 flag_sj
🇹🇦 flag_ta
🇺🇲 flag_um
🇺🇳 united_nations
0⃣ zero
1⃣ one
2⃣ two
3⃣ three
4⃣ four
5⃣ five
6⃣ six
7⃣ seven
8⃣ eight
9⃣ nine
🏻 skin-tone-1
🏼 skin-tone-2
🏽 skin-tone-3
🏾 skin-tone-4
🏿 skin-tone-5
`.trim()
